import { render, staticRenderFns } from "./ReadBooks.vue?vue&type=template&id=91feb5e8&"
import script from "./ReadBooks.vue?vue&type=script&lang=js&"
export * from "./ReadBooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports